// pro duotone icons (fad)
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

export default (library) => {
    library.add(faSpinnerThird);
};
